import get from "lodash/get";
import { frequencyList } from "./constants";

export const getFrequencyText = (frequencyType) => {
	return get(frequencyList, frequencyType);
};
